import { HYDRATE } from 'next-redux-wrapper';

import { IShopItem } from '@r1-frontend/api-domru/api-content/v1/shop/items';
import { IBanner } from '@r1-frontend/api-domru/api-content/v2/banner-city';

import { THydrateAction } from '~/src/store';

export enum ESubscriptionsDomruTvActions {
    FETCH_SUBSCRIPTIONS = 'FETCH_SUBSCRIPTIONS',
    FETCH_BANNERS = 'FETCH_BANNERS',
}

export interface ISubscriptionsDomruTvState {
    items: IShopItem[],
    banners: IBanner[],
}

const initialState: ISubscriptionsDomruTvState = {
    items: [],
    banners: [],
};

type TActions = {
    type: ESubscriptionsDomruTvActions,
    payload: ISubscriptionsDomruTvState,
}

const tvSubscriptions = (state = initialState, action: TActions | THydrateAction): ISubscriptionsDomruTvState => {
    switch (action.type) {
        case HYDRATE:
            return { ...state };
        case ESubscriptionsDomruTvActions.FETCH_SUBSCRIPTIONS:
            return { ...state, ...action.payload };
        case ESubscriptionsDomruTvActions.FETCH_BANNERS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default tvSubscriptions;
